// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPayrollContributionsMultiEmployersSummaryRecordDto
 */
export interface IPayrollContributionsMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IPayrollContributionsMultiEmployersSummaryRecordDto
     */
    account_type?: string;
    /**
     * 
     * @type {number}
     * @memberof IPayrollContributionsMultiEmployersSummaryRecordDto
     */
    total_employee_contributions?: number;
    /**
     * 
     * @type {number}
     * @memberof IPayrollContributionsMultiEmployersSummaryRecordDto
     */
    total_employer_contributions?: number;
    /**
     * 
     * @type {number}
     * @memberof IPayrollContributionsMultiEmployersSummaryRecordDto
     */
    total_contributions?: number;
}

/**
 * Check if a given object implements the IPayrollContributionsMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIPayrollContributionsMultiEmployersSummaryRecordDto(value: object): value is IPayrollContributionsMultiEmployersSummaryRecordDto {
    return true;
}

export function IPayrollContributionsMultiEmployersSummaryRecordDtoFromJSON(json: any): IPayrollContributionsMultiEmployersSummaryRecordDto {
    return IPayrollContributionsMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IPayrollContributionsMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollContributionsMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'total_employee_contributions': json['total_employee_contributions'] == null ? undefined : json['total_employee_contributions'],
        'total_employer_contributions': json['total_employer_contributions'] == null ? undefined : json['total_employer_contributions'],
        'total_contributions': json['total_contributions'] == null ? undefined : json['total_contributions'],
    };
}

export function IPayrollContributionsMultiEmployersSummaryRecordDtoToJSON(json: any): IPayrollContributionsMultiEmployersSummaryRecordDto {
    return IPayrollContributionsMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IPayrollContributionsMultiEmployersSummaryRecordDtoToJSONTyped(value?: IPayrollContributionsMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_type': value['account_type'],
        'total_employee_contributions': value['total_employee_contributions'],
        'total_employer_contributions': value['total_employer_contributions'],
        'total_contributions': value['total_contributions'],
    };
}

